import { z } from 'zod';
import { pageParam, pageSizeParam } from '../_shared/coerce.js';
/**
 * Catégories des questions posées au chatbot, code → libellé BO.
 *
 * Le code est stocké tel quel dans `chat_questions.category` : le renommer
 * rend orphelines les lignes déjà classées. Le libellé change librement.
 * Liste de départ, à valider avec Massilia.
 */
export const CHAT_QUESTION_CATEGORIES = {
    annulation: 'Annulation et remboursement',
    autre: 'Autre',
    bagages: 'Bagages',
    conseils: 'Conseils et idées de voyage',
    contact: 'Contact et agences',
    formalites: 'Visa et formalités',
    paiement: 'Paiement',
    prix: 'Prix et promotions',
    recherche_vol: 'Recherche de vol',
    reservation: 'Réservation et modification',
    sejours: 'Séjours et hôtels',
    vols: 'Vols et horaires',
};
export function isChatQuestionCategory(value) {
    return Object.hasOwn(CHAT_QUESTION_CATEGORIES, value);
}
const categorySchema = z.string().refine(isChatQuestionCategory);
/**
 * Durée de conservation des questions, lue par la purge nocturne et affichée
 * dans le BO. À confirmer avec Massilia (RGPD) : les messages peuvent contenir
 * des données personnelles (nom, numéro de dossier).
 */
export const CHAT_QUESTION_RETENTION_MONTHS = 12;
export const CHAT_QUESTION_PERIODS = ['7d', '30d', '90d', 'all'];
const periodSchema = z.enum(CHAT_QUESTION_PERIODS).default('30d');
/**
 * `unanswered` : le classement juge que le chatbot n'a pas vraiment répondu
 * (trou dans la base de connaissances). `disliked` : au moins un 👎 du visiteur.
 */
export const CHAT_CONVERSATION_FLAGS = ['unanswered', 'disliked'];
export const getChatConversationsQuerySchema = z.object({
    // `uncategorized` : les conversations que le cron n'a pas encore classées.
    category: z.union([categorySchema, z.literal('uncategorized')]).optional(),
    flag: z.enum(CHAT_CONVERSATION_FLAGS).optional(),
    page: pageParam(),
    pageSize: pageSizeParam(50),
    period: periodSchema,
    search: z.string().trim().optional(),
});
export const getChatQuestionCategoryCountsQuerySchema = z.object({ period: periodSchema });
